import React from 'react';

function TourPackages() {
  const packages = Array(5).fill({
    price: '$ 950.00 USD',
    title: 'Adventures in Japan',
    description: 'Etiam ac tortor id purus commodo vulputate. Vestibulum porttitor erat felis and sed vehicula tortor malesuada gravida. Mauris volutpat.',
  });

  return (
    <section className="package-section section-padding fix">
      <div className="container">
        <div className="section-title text-center mb-0">
          <span className="sub-title style-2 wow fadeInUp">
            Explore the world
          </span>
          <h2 className="wow fadeInUp" data-wow-delay=".3s">
            World's Amazing Tour Package
          </h2>
        </div>
        <div className="package-wrapper">
          <div className="row">
            <div className="col-12">
              <ul className="package-nav" role="tablist">
                <li className="package-item">
                  <a href="#all" data-bs-toggle="tab" className="nav-link active" aria-selected="true" role="tab">All</a>
                </li>
                <li className="package-item">
                  <a href="#thailand" data-bs-toggle="tab" className="nav-link" aria-selected="false" role="tab">Thailand</a>
                </li>
                <li className="package-item">
                  <a href="#manhattan" data-bs-toggle="tab" className="nav-link" aria-selected="false" role="tab">Manhattan</a>
                </li>
                <li className="package-item">
                  <a href="#pearland" data-bs-toggle="tab" className="nav-link" aria-selected="false" role="tab">Pearland</a>
                </li>
                <li>
                  <a href="#maldives" data-bs-toggle="tab" className="nav-link" aria-selected="false" role="tab">Maldives</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="tab-content">
            {['all', 'thailand', 'manhattan', 'pearland', 'maldives'].map((tab, tabIndex) => (
              <div
                key={tab}
                id={tab}
                className={`tab-pane fade ${tab === 'all' ? 'active show' : ''}`}
                role="tabpanel"
              >
                <div className="row g-4 mt-1">
                  <div className="col-lg-6">
                    <div className="package-thumb">
                      <img
                        src="./assets/img/package/1.jpg"
                        alt="img"
                        className="wow img-custom-anim-top"
                        data-wow-delay=".1s"
                      />
                      <div className="content">
                        <span className="price">{packages[0].price}</span>
                        <h3>{packages[0].title}</h3>
                        <p>{packages[0].description}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row g-4">
                      <div className="col-lg-6">
                        <div className="package-thumb">
                          <img
                            src="./assets/img/package/2.jpg"
                            alt="img"
                            className="wow img-custom-anim-top"
                            data-wow-delay=".3s"
                          />
                          <div className="content style-2">
                            <span className="price">{packages[1].price}</span>
                            <h3>{packages[1].title}</h3>
                            <p>{packages[1].description.split('. ')[0]}.</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="package-thumb">
                          <img
                            src="./assets/img/package/3.jpg"
                            alt="img"
                            className="wow img-custom-anim-top"
                            data-wow-delay=".5s"
                          />
                          <div className="content style-2">
                            <span className="price">{packages[2].price}</span>
                            <h3>{tab === 'maldives' ? 'Adventures in Maldives' : packages[2].title}</h3>
                            <p>{packages[2].description.split('. ')[0]}.</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="package-thumb">
                          <img
                            src="./assets/img/package/4.jpg"
                            alt="img"
                            className="wow img-custom-anim-top"
                            data-wow-delay=".8s"
                          />
                          <div className="content">
                            <span className="price">{packages[3].price}</span>
                            <h3>{packages[3].title}</h3>
                            <p>{packages[3].description}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default TourPackages;